// 1 COIN = 100 units. Store units (int), show COIN (2 decimals).
export const fmt = (units: number) => (units / 100).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
export const toUnits = (coin: number) => Math.round(coin * 100);
